import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
  "Vertical stacking of cars up to 20+ levels",
  "Smallest footprint with maximum capacity",
  "Fully automatic system – no human intervention required",
  "Fast retrieval time with intelligent car positioning",
  "Highly secure and weather-protected structure",
];

const applications = [
  "High-Rise Residential Towers",
  "Premium Commercial Complexes",
  "Hotels & Convention Centers",
  "Government Buildings",
  "Smart Cities & Metro Stations",
];

const TowerParkingDetail = () => {
    const navigate = useNavigate()
  return (
    <section className="about-wrapper">
      {/* Hero */}
      <div className="about-hero">
        <div className="hero-content">
          <h1>Tower Parking System</h1>
          <p>
            A cutting-edge automatic vertical parking solution that maximizes vehicle capacity using minimal land area — ideal for high-density cities and premium real estate.
          </p>
        </div>
      </div>

      {/* Description */}
      <div className="about-section">
        <h2>What is Tower Parking?</h2>
        <p>
          Tower Parking is a fully automatic car parking system that uses vertical towers to stack vehicles in multiple levels — typically 8 to 20 stories high. It requires a very small base area and uses an integrated lift and shuttle mechanism to move cars into and out of parking bays.
        </p>
        <p>
          This system is especially suited for urban locations where land cost is high and traditional parking is not feasible. It offers unmatched capacity, safety, and automation.
        </p>
      </div>

      {/* Features */}
      <div className="about-section">
        <h2>Key Features & Benefits</h2>
        <ul className="lt-puzzle-list">
          {features.map((item, index) => (
            <li key={index}><CheckCircle size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* How it Works */}
      <div className="about-section">
        <h2>How It Works</h2>
        <p>
          Vehicles are driven onto a turntable or entry bay at ground level. The system identifies a vacant slot and automatically lifts the vehicle vertically to the assigned level, then shifts it horizontally into place. Retrieval is just as seamless — the car descends and turns to face forward for the driver.
        </p>
        <p>
          The system operates through advanced PLC logic and safety systems, with features like real-time monitoring, password/RFID access, fire sensors, and emergency overrides.
        </p>
      </div>

      {/* Applications */}
      <div className="about-section">
        <h2>Best Suited For</h2>
        <ul className="lt-puzzle-list">
          {applications.map((item, index) => (
            <li key={index}><Building2 size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* Call to Action */}
      <div className="lt-puzzle-cta">
        <div className="lt-puzzle-cta-content">
          <h3>Want to integrate a Tower Parking System?</h3>
          <p>Reach out to LIFTECH ENGINEERING PVT. LTD. for customized tower parking solutions for your building or smart project.</p>
          <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
            <PhoneCall size={18} /> Request Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default TowerParkingDetail;
